<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  active: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  recording: { type: Object, default: null },
});
const emit = defineEmits(['record', 'discard', 'playStop']);
const { t } = useI18n();
const ready = computed(() => props.recording?.stage === 'ready');
const actionEnabled = computed(
  () => ready.value || props.recording?.stage === 'recording'
);
const actionIcon = computed(() => {
  if (!ready.value) return 'i-ph-stop';
  return props.recording.playing ? 'i-ph-pause' : 'i-ph-play';
});
const actionLabel = computed(() => {
  if (!ready.value) return t('INTERNAL_CHAT.AUDIO_STOP');
  return props.recording.playing
    ? t('INTERNAL_CHAT.AUDIO_PAUSE_PREVIEW')
    : t('INTERNAL_CHAT.AUDIO_PLAY_PREVIEW');
});
const recordLabel = computed(() =>
  props.active
    ? t('INTERNAL_CHAT.AUDIO_DISCARD')
    : t('INTERNAL_CHAT.AUDIO_RECORD')
);
const toggleRecorder = () => {
  if (props.active) emit('discard');
  else emit('record');
};
</script>

<template>
  <Button
    type="button"
    variant="faded"
    color="slate"
    size="sm"
    :icon="active ? 'i-ph-microphone-slash' : 'i-ph-microphone'"
    :aria-label="recordLabel"
    :title="recordLabel"
    :disabled="disabled"
    data-testid="internal-chat-record-audio"
    @click="toggleRecorder"
  />
  <Button
    v-if="active"
    type="button"
    variant="faded"
    color="slate"
    size="sm"
    :icon="actionIcon"
    :aria-label="actionLabel"
    :title="actionLabel"
    :disabled="disabled || !actionEnabled"
    data-testid="internal-chat-audio-play-stop"
    @click="emit('playStop')"
  >
    <span class="tabular-nums" data-testid="internal-chat-audio-duration">{{
      recording?.progress || '00:00'
    }}</span>
  </Button>
</template>
